<template>
    <div class="all">
        <div class="por">
            <div class="w350 ml20 fr">
                <div class="grid h-auto">
                    <div class="grid-header clearfix">
                        <h2 class="title">热门专题</h2>
                    </div>
                    <div class="grid-body mt15">
                        <ul class="event">
                            <li v-for="(item,index) in hotTopicsList" :key="index">
                                <router-link class="img" :to="{path:''+$parent.baseUrl+'/specialDetail',query:{id:item.id,name:item.name}}">
                                    <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                                    <span class="name ac db">{{item.name}}</span>
                                </router-link>
                            </li>
                        </ul>
                        <div class="no-data pt30" v-if="nodata.hotTopicsList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="events-warp">
                <div class="screen">
                    <div class="item clearfix">
                        <span class="zu clearfix">
                            <span class="name">类别</span>
                            <span class="drop-down mores">
                                <button class="btn btn-lightblue"><span class="text">{{typeName != '全部' ? hotTypeList[typeName] : '全部'}}</span><i class="icons"></i></button>
                                <ul class="option">
                                    <li @click="choseType(0)">全部</li>
                                    <li v-for="(item,index) in hotTypeList" :key="index" @click="choseType(index)">{{item}}</li>
                                </ul>
                            </span>
                        </span>

                        <span class="zu clearfix">
                            <span class="name">发布地区</span>
                            <city @cityCallback="citySelect"></city>
                        </span>
                        
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down">
                                <vue-datepicker-local ref="timeSelect" v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons clearable @clear="selectedDate" @confirm="selectedDate" placeholder="请选择时间"/>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="warp mt20 clearfix">
                    <div class="warp-body mh270">
                        <div class="no-data" v-if="nodata.hotList"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                        <ul class="article-list">
                            <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                                <router-link class="img fl" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank"><img :src="[item.icon]" :onerror="defaultImg"/></router-link>
                                <div class="hidden">
                                    <div class="clearfix">
                                        <h2 class="fl"><router-link class="cr3d" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank">{{item.name}}</router-link></h2>
                                        <span class="fr">舆情指数 <strong class="color-blue fs18">{{item.exponent}}</strong></span>
                                    </div>
                                    <p class="mt5 ovhidden3">{{item.schemeDescription}}</p>
                                    <p class="ziduan mt10">
                                        <a class="tag tag-blue" href="javascript:void(0);" @click="choseType(item.typeId);">{{hotTypeList[item.typeId]}}</a>　<span>{{item.createTime | timeFilter}}</span>
                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                        <div class="mt20 ac" v-if="isShowMore">
                            <a class="more color-8a8a99" href="javascript:void(0);" @click="showMore">点击加载更多</a>
                        </div>
                        <div class="mt20 ac" v-if="isShowEnd">
                            <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components:{VueDatepickerLocal,city},
    data() {
        return {
            hotTopicsList:[],
            hotTypeList:[],
            defaultImg:'this.src="'+this.$parent.baseUrl+'/static/images/default.png"',
            typeName:'全部',
            tags:'全部',
            hotList:[],
            pageCur:1,
            pageNum:6,
            dataCount:0,
            timeRange: [],
            startTime:null,
            endTime:null,
            province:'',//省份
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                hotTopicsList:false,
                hotList:false
            }
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            //获取事件ID
            if(that.$route.query.type != undefined){
                that.typeName = that.$route.query.type;
            }
            // that.initialTime();
            // that.timeRange = [];
            that.dataAjax();
            that.hotListAjax();
        })
    },
    filters:{
        typeFilter:function(value,typeArr){
            return typeArr[value]
        },
        timeFilter:function(val){
            return val.split(" ")[0];
        },
    },
    methods: {
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2])
            min = new Date(o[0], o[1]-1, o[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);
            this.endDate = this.$utils.dateConversion(max,1);
        },
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('hotnews/index/hot-topics',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotTopicsList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata.hotTopicsList = true;
                    }else{
                        that.nodata.hotTopicsList = false;
                    }
                });
            });
            that.$api.get('hotnews/index/hot-news-type',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotTypeList = r.data;
                    that.$parent.loadModal(false);
                });
            });
        },
        // 地区筛选
        citySelect (name) {
            let province = name[1];
            let that = this;
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.clearListData();
        },
        hotListAjax(){
            let that = this;
            that.$api.get('hotnews/hot-news/list',{type:that.typeName,tags:that.tags,startTime:that.startTime,endTime:that.endTime,province:that.province,perpage:that.pageNum,page:that.pageCur},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.list.length<=0){
                        that.nodata.hotList = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                    }
                    that.dataCount = r.data.count;
                    if(that.dataCount>that.pageNum*that.pageCur){
                        that.isShowMore = true;
                    }else{
                        that.isShowMore = false;
                        that.isShowEnd = true;
                    }
                    that.hotList = that.hotList.concat(r.data.list);
                });
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            if(that.dataCount>((that.pageCur-1)*that.pageNum)){
                that.hotListAjax();
            }
        },
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        choseType(type){
            let that = this;
            that.typeName = type;
            that.clearListData();
        },
       
        disabledDate (time) {
            //return time < this.min || time > this.max
        },
        selectedDate (date) {
            let that = this;
            if(date == undefined){
                that.startTime = '';
                that.endTime = '';  
            }else{
                that.startTime = that.$utils.dateConversion(that.timeRange[0],1);
                that.endTime = that.$utils.dateConversion(that.timeRange[1],1);
            }
            that.clearListData();
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/eventsKu.vue